
import { Modal } from "bootstrap";
import { defineComponent, ref, inject } from "vue";
import { Input } from "@/components/input-elements";
import { Apollo, Notify } from "@/core/services";
import { GET_PRICE_GROUP } from "@/modules/customer/price-groups/graphql/Queries";
import { UPDATE_PRICE_GROUP } from "@/modules/customer/price-groups/graphql/Mutations";
import { EditPriceGroupForm } from "@/modules/customer/price-groups/interfaces";
import { useI18n } from "vue-i18n";
import InnerLoader from "@/components/InnerLoader.vue";

export default defineComponent({
	name: "edit price group",
	components: {
		Input,
		InnerLoader,
	},

	setup() {
		const modal: any = ref();
		const loading = ref(false);
		const emitter: any = inject("emitter");
		const current_page = ref(1);
		const i18n = useI18n();
		const editPriceGroupForm = ref<null | HTMLFormElement>(null);

		// Given Edit Price Group Form Interface
		const editPriceGroupData = ref<EditPriceGroupForm>({
			id: null,
			name: "",
		});

		// Submit Hanlder Request
		const submitHandlerForm = async () => {
			editPriceGroupForm.value?.validate(async (valid: boolean) => {
				if (valid) {
					const formData = {
						id: editPriceGroupData.value.id,
						name: editPriceGroupData.value.name,
					};

					loading.value = true;
					await Apollo.mutate({
						mutation: UPDATE_PRICE_GROUP,
						variables: { input: formData },
						update: (store, { data: { update_price_group } }) => {
							// const pervious_record = store.readQuery({
							// 	query: GET_PRICE_GROUP,
							// 	variables: {
							// 		page: current_page.value,
							// 		limit: 10,
							// 	},
							// }) as Record<any, any>;
							// store.writeQuery({
							// 	query: GET_PRICE_GROUP,
							// 	variables: {
							// 		page: current_page.value,
							// 		limit: 10,
							// 	},
							// 	data: {
							// 		price_groups: {
							// 			...pervious_record.price_groups,
							// 		},
							// 		variables: {
							// 			id: update_price_group.id,
							// 		},
							// 	},
							// });
							modal.value.hide();
							loading.value = false;
							Notify.success(`${i18n.t("message.RECORD_UPDATED_SUCCESSFULLY")}`);
						},
					}).catch((e) => {
						console.log(e);
						loading.value = false;
					});
				}
			});
		};

		// Reset Form Data On Model Popup
		const resetForm = () => {
			emitter.emit("clearInput");
			current_page.value = 1;
			editPriceGroupForm.value?.resetFields();
		};

		// Emitter To Open Model
		emitter.on("editPriceGroupAction", (price_group: Record<any, any>) => {
			resetForm();
			current_page.value = price_group.current_page;
			editPriceGroupData.value.id = price_group.id;
			editPriceGroupData.value.name = price_group.name;
			modal.value = new Modal(document.getElementById("modal_edit_price_group"));
			modal.value.show();
		});

		return {
			loading,
			editPriceGroupData,
			editPriceGroupForm,
			submitHandlerForm,
		};
	},
});
